module.exports = __webpack_public_path__ + "static/media/Enviar.d9f26174.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/SupervisorChat/Enviar.svg
// module id = 1830
// module chunks = 0